import { Platform } from 'utils/platform';

import { TvResetPinConfirmModal } from './TvResetPinConfirmModal';
import { WebResetPinConfirmModal } from './WebResetPinConfirmModal';

export type ResetPinConfirmModalProps = {
  isOpen: boolean;
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ResetPinConfirmModal = (props: ResetPinConfirmModalProps) => {
  if (Platform.isTV) {
    return <TvResetPinConfirmModal {...props} />;
  }

  return <WebResetPinConfirmModal {...props} />;
};
